import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Weather} from "../model/weather.model";
import {Observable} from "rxjs";
import {CalcWeatherIconParams} from "../model/calc-weather-icon-params.interface";
import {WEATHER_ICONS_MAP} from "../const/weather-icon-map.const";
import * as moment from "moment";
import {WeatherCalcInfo} from "../model/weather-calc-info.model";
import {CacheService} from "../common/service/cache-http.service";
import {APP_CONFIG_PARAMS} from "../const/app-config";

@Injectable({
  providedIn: 'root'
})
export class WeatherService {

  private _baseUrl: string = environment.host + "/weather";

  constructor(private httpClient: HttpClient) {
  }

  getWeather(): Observable<Weather> {
    return this.httpClient.get<Weather>(this._baseUrl);
  }

  calculateWeatherStyle(params: CalcWeatherIconParams): WeatherCalcInfo {
    // soglie configurabili
    const RAIN_PROBABILITY_THRESHOLD = 20; // se prob >= 30 consideriamo possibilità di pioggia
    const STORM_WIND_THRESHOLD = 50;       // vento oltre questo valore può causare "tempesta"

    // normalizza input (gestisce null/undefined)
    const precipitation = params.precipitation ?? 0;
    const precipProb = params.precipitationProbability ?? 0;
    const windSpeed = params.windSpeed ?? 0;
    const cloudCover = params.cloudCover ?? params.cloudCoverTotal ?? 0;
    const isDay = params.isDay ?? true;

    const willRain = precipitation > 0 || precipProb >= RAIN_PROBABILITY_THRESHOLD;

    const calc: WeatherCalcInfo = { icon: '', label: '', wClass: undefined };

    // Priorità: tempesta (vento + precipitazione reale), poi pioggia (reale o probabile), poi nuvoloso, parziale, sereno
    if (willRain) {
      // se c'è precipitazione effettiva e vento molto forte -> tempesta
      if (precipitation > 0 && windSpeed >= STORM_WIND_THRESHOLD) {
        calc.icon = WEATHER_ICONS_MAP.TEMPESTA;
        calc.label = 'temporale';
        calc.wClass = 'storm';
        return calc;
      }

      // se c'è precipitazione effettiva -> pioggia
      if (precipitation > 0) {
        calc.icon = WEATHER_ICONS_MAP.PIOGGIA;
        calc.label = 'pioggia';
        calc.wClass= 'rainy';
        return calc;
      }

      // qui: niente precipitazione misurata ma probabilità alta
      // scegli label più prudente (possibili piogge) oppure "pioggia" se vuoi essere più assertivo
      calc.icon = WEATHER_ICONS_MAP.PIOGGIA_NUVOLE;
      calc.label = precipProb >= 60 ? 'pioggia probabile' : 'possibili piogge';
      calc.wClass= 'rainy';
      return calc;
    }

    // non c'è probabilità/rilevamento di pioggia: decidi in base alle nuvole
    if (cloudCover > 80) {
      calc.icon = WEATHER_ICONS_MAP.NUVOLOSO;
      calc.label = 'nuvoloso';
      calc.wClass= 'cloud';
    } else if (cloudCover > 20 && cloudCover <= 80) {
      calc.icon = isDay ? WEATHER_ICONS_MAP.NUVOLOSO_SOLE : WEATHER_ICONS_MAP.NUVOLOSO_LUNA;
      calc.label = 'parzialmente nuvoloso';
      calc.wClass = isDay ? 'cloud-day' : 'cloud-night';
    } else {
      calc.icon = isDay ? WEATHER_ICONS_MAP.SOLE_SERENO : WEATHER_ICONS_MAP.LUNA_SERNEO;
      calc.label = 'sereno';
      calc.wClass = isDay ? 'sunny' : 'moon';
    }

    return calc;
  }

}
